export default __webpack_public_path__ + "static/media/logout.146de356.svg";